import styled from "styled-components";

export const DailyDealChestHaloBox = styled.div`

    background: url(${({theme}) => theme.assets.images.daily_deal.daily_deal_chest_halo_png.toString()}) center no-repeat;
    position: relative;
    bottom: 15px;
        
    grid-column: 1;
    grid-row: 1;
    
    height: 90px;
    width: 83px;  
    z-index: -1;
`;
